import './divider.css'
const Divider = () => {
    return (
        <p>
            •• ━━━━━ ••●•• ━━━━━ ••
        </p>
    )
}
export default Divider